import {
	IChipPrimaryField,
	IItemLabelPrimaryField,
	IItemLabelSecondaryField,
	LuTypeaheadChipLabelOptions,
	LuTypeaheadItemTitleLabelOptions,
	LuTypeaheadOptions,
	LuTypeaheadSelectAll
} from 'lu-typeahead';

export class LuTypeaheadOptionsBuilder {
	private labelField: string;
	private secondaryLabelField: string;
	private primaryFieldFormatter: any;
	private secondaryFieldFormatter: any;
	private chipField: string;
	private selectAs: string;
	private filterBy: string;
	private searchPlaceholder: string;
	private maxSelections: number;
	private paginate: boolean;
	private alwaysOpen: boolean;
	private isAbsolute: boolean;
	private initFocus: boolean;
	private disabled: boolean;
	private selectAll: Partial<LuTypeaheadSelectAll>;
	private isScrollable: boolean;
	private isMultiselectView: boolean;
	private showFooterActions: boolean;
	private showFilterClear: boolean;

	constructor(labelField?: string, selectAs?: string, filterBy?: string) {
		this.setLabelField(labelField || null)
			.setChipField(labelField || null)
			.setSelectAs(selectAs || null)
			.setFilterBy(filterBy || null);
	}

	public setLabelField(labelField: string): this {
		this.labelField = labelField;
		return this;
	}

	public setSecondaryLabelField(secondaryLabelField: string): this {
		this.secondaryLabelField = secondaryLabelField;
		return this;
	}

	public setPrimaryFieldFormatter(primaryFieldFormatter: any): this {
		this.primaryFieldFormatter = primaryFieldFormatter;
		return this;
	}

	public setSecondaryFieldFormatter(secondaryFieldFormatter: any): this {
		this.secondaryFieldFormatter = secondaryFieldFormatter;
		return this;
	}

	public setChipField(chipField: string): this {
		this.chipField = chipField;
		return this;
	}

	public setSelectAs(selectAs: string): this {
		this.selectAs = selectAs;
		return this;
	}

	public setSelectAll(selectAll: Partial<LuTypeaheadSelectAll>): this {
		this.selectAll = selectAll;
		return this;
	}

	public setFilterBy(filterBy: string): this {
		this.filterBy = filterBy;
		return this;
	}

	public setSearchPlaceholder(searchPlaceholder: string): this {
		this.searchPlaceholder = searchPlaceholder;
		return this;
	}

	public setMaxSelections(maxSelections: number): this {
		this.maxSelections = maxSelections;
		return this;
	}

	public setPaginate(paginate: boolean): this {
		this.paginate = paginate;
		return this;
	}

	public setAlwaysOpen(alwaysOpen: boolean): this {
		this.alwaysOpen = alwaysOpen;
		return this;
	}

	public setIsAbsolute(isAbsolute: boolean): this {
		this.isAbsolute = isAbsolute;
		return this;
	}

	public setInitFocus(initFocus: boolean): this {
		this.initFocus = initFocus;
		return this;
	}

	public setDisabled(disabled: boolean): this {
		this.disabled = disabled;
		return this;
	}

	public setIsMultiselectView(isMultiselectView: boolean): this {
		this.isMultiselectView = isMultiselectView;
		return this;
	}

	public setShowFooterActions(showFooterActions: boolean): this {
		this.showFooterActions = showFooterActions;
		return this;
	}

	public setShowFilterClearAction(showFilterClear: boolean): this {
		this.showFilterClear = showFilterClear;
		return this;
	}

	public setIsScrollable(isScrollable: boolean): this {
		this.isScrollable = isScrollable;
		return this;
	}

	public build(): LuTypeaheadOptions {
		const primaryField: IItemLabelPrimaryField = {
			field: this.labelField
		};

		if (this.primaryFieldFormatter != null) {
			primaryField.formatter = this.primaryFieldFormatter;
		}

		let itemOptions: LuTypeaheadItemTitleLabelOptions;
		if (this.secondaryLabelField != null) {
			const secondaryField: IItemLabelSecondaryField = {
				field: this.secondaryLabelField
			};

			if (this.secondaryFieldFormatter != null) {
				secondaryField.formatter = this.secondaryFieldFormatter;
			}

			itemOptions = new LuTypeaheadItemTitleLabelOptions(primaryField, secondaryField);
		} else {
			itemOptions = new LuTypeaheadItemTitleLabelOptions(primaryField);
		}

		const chipPrimaryField: IChipPrimaryField = {
			field: this.chipField
		};

		const chipOptions = new LuTypeaheadChipLabelOptions(chipPrimaryField);

		const options: LuTypeaheadOptions = {
			itemOptions: itemOptions,
			chipOptions: chipOptions,
			maxSelections: this.maxSelections,
			paginate: this.paginate,
			alwaysOpen: this.alwaysOpen,
			selectAs: this.selectAs,
			filterBy: this.filterBy,
			isAbsolute: this.isAbsolute,
			searchPlaceholder: this.searchPlaceholder,
			initFocus: this.initFocus,
			disabled: this.disabled,
			selectAll: this.selectAll,
			isScrollable: this.isScrollable,
			isMultiselectView: this.isMultiselectView,
			showFooterActions: this.showFooterActions,
			showFilterClear: this.showFilterClear
		};
		return options;
	}
}
